export default 'mpi_view_market_financials';
